export const SOCKET_PATH = '/api/socket.io';

export const USER_TYPES = {
  ADMIN: 'admin',
  CANDIDATE: 'candidate'
};

export const SESSION_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed'
};
